export * from '@fhs/routing/src/routes/(drawer)/account/gift-cards';
export { default } from '@fhs/routing/src/routes/(drawer)/account/gift-cards';
